/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import actionCreatorFactory from 'typescript-fsa';
import { GroupInternalHighscore, UserGroup, UserGroupDetail } from '../../services/betting';

const actionCreator = actionCreatorFactory();

export const SET_GROUP_INTERNAL_HIGHSCORES = 'SET_GROUP_INTERNAL_HIGHSCORES';
export const setGroupInternalHighscores = actionCreator<GroupInternalHighscore>(SET_GROUP_INTERNAL_HIGHSCORES);

export interface GroupInternalHighscoreParams {
    trId?: string;
    ugId?: string;
}

export const LOAD_GROUP_INTERNAL_HIGHSCORES = 'LOAD_GROUP_INTERNAL_HIGHSCORES';
export const loadGroupInternalHighscores = actionCreator<GroupInternalHighscoreParams>(LOAD_GROUP_INTERNAL_HIGHSCORES);

export const SET_GROUP_INTERNAL_USER_GROUP_ID = 'SET_GROUP_INTERNAL_USER_GROUP_ID';
export const setGroupInternalUserGroupId = actionCreator<number>(SET_GROUP_INTERNAL_USER_GROUP_ID);

export const GIHS_SET_GROUP_DETAILS = 'GIHS_SET_GROUP_DETAILS';
export const gihsSetGroupDetails = actionCreator<UserGroupDetail>(GIHS_SET_GROUP_DETAILS);

export const GIHS_SET_IS_LOADING = 'GIHS_SET_IS_LOADING';
export const gihsSetIsLoading = actionCreator<boolean>(GIHS_SET_IS_LOADING);

export const GIHS_SET_AVAILABLE_GROUPS = 'GIHS_SET_AVAILABLE_GROUPS';
export const gihsSetAvailableGroups = actionCreator<UserGroup[]>(GIHS_SET_AVAILABLE_GROUPS);

export const GIHS_SET_COLUMN_COUNT = 'GIHS_SET_COLUMN_COUNT';
export const gihsSetColumnCount = actionCreator<number>(GIHS_SET_COLUMN_COUNT);

export const GIHS_SET_START_COLUMN = 'GIHS_SET_START_COLUMN';
export const gihsSetStartColumn = actionCreator<number>(GIHS_SET_START_COLUMN);

export const GIHS_COLUMN_LEFT = 'GIHS_COLUMN_LEFT';
export const gihsColumnLeft = actionCreator(GIHS_COLUMN_LEFT);

export const GIHS_COLUMN_RIGHT = 'GIHS_COLUMN_RIGHT';
export const gihsColumnRight = actionCreator(GIHS_COLUMN_RIGHT);

export const GIHS_SET_COLUMNS_ENABLED = 'GIHS_SET_COLUMNS_ENABLED';
export const gihsSetColumnsEnabled = actionCreator<{ leftEnabled: boolean; rightEnabled: boolean }>(
    GIHS_SET_COLUMNS_ENABLED
);

export const GIHS_TR_ID_CHANGED = 'GIHS_TR_ID_CHANGED';
export const gihsTrIdChanged = actionCreator<string>(GIHS_TR_ID_CHANGED);

export const GIHS_TOURNAMENT_ID_CHANGED = 'GIHS_TOURNAMENT_ID_CHANGED';
export const gihsTournamentIdChanged = actionCreator<string>(GIHS_TOURNAMENT_ID_CHANGED);

export const GIHS_LOAD_WITH_PROPS = 'GIHS_LOAD_WITH_PROPS';
export const gihsLoadWithProps = actionCreator<GroupInternalHighscoreParams>(GIHS_LOAD_WITH_PROPS);

export const GIHS_LOAD_WITHOUT_PROPS = 'GIHS_LOAD_WITHOUT_PROPS';
export const gihsLoadWithoutProps = actionCreator(GIHS_LOAD_WITHOUT_PROPS);
